/**
 * Admin auth session helpers (JWT in localStorage).
 * Backend still owns real invalidation (TTL, password-change revoke).
 */

let loggingOut = false;

export function clearAuthStorage() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('Email');
  } catch (_) {
    /* ignore */
  }
}

/**
 * Clear session and force login screen.
 * Safe to call multiple times (deduped while redirect is in progress).
 */
export function forceLogout(reason) {
  if (loggingOut) return;
  loggingOut = true;
  if (reason && typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.info('[auth] logout:', reason);
  }
  clearAuthStorage();
  const hash = typeof window !== 'undefined' ? window.location.hash || '' : '';
  const alreadyOnLogin = hash.includes('/login');
  if (!alreadyOnLogin && typeof window !== 'undefined') {
    window.location.hash = '#/login';
    window.location.reload();
  } else {
    loggingOut = false;
  }
}

/** Decode JWT payload without verifying signature (client UX only). */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * @returns {boolean} true if token is missing, malformed, or past `exp`
 */
export function isAccessTokenExpired(token = null) {
  const value = token != null ? token : (() => {
    try {
      return localStorage.getItem('token');
    } catch {
      return null;
    }
  })();
  if (!value) return true;
  const payload = decodeJwtPayload(value);
  if (!payload || typeof payload.exp !== 'number') {
    // Cannot read exp — treat as still usable; backend will 401 if invalid.
    return false;
  }
  // Small skew so we logout slightly before hard expiry.
  const skewSec = 5;
  return payload.exp * 1000 <= Date.now() + skewSec * 1000;
}
